import React from "react"
import Components from ".."
import { blokType, sbAssetType } from "../../types"

import {
  StyledHero,
  StyledHeroContainer,
  StyledHeroButtons,
  StyledHeroContent,
  StyledHeader,
  StyledTitle,
  StyledDesc,
  StyledBgImg,
  StyledShape,
} from "./partials"

export interface HeroProps {
  title: string
  description: string
  cta_button: blokType[]
  image: blokType[]
  sub_title: string
  shape: sbAssetType
  id: string,
  custom_id: string,
}

export const HeroCmp: React.FC<HeroProps> = ({
  title,
  description,
  cta_button,
  image,
  shape,
  id,
  custom_id,
}) => {
  return (
    <StyledHero data-name="hero-homepage" id={custom_id ? custom_id : id}>
      <StyledHeroContainer>
        <StyledHeroContent>
          <StyledHeader>
            <StyledTitle>{title && title}</StyledTitle>
            <StyledDesc>{description && description}</StyledDesc>
            {cta_button && cta_button.length > 0 && (
              <StyledHeroButtons>
                {cta_button.map((content) =>
                  React.createElement(Components(content.component), {
                    key: content._uid,
                    blok: content,
                  })
                )}
              </StyledHeroButtons>
            )}
          </StyledHeader>
        </StyledHeroContent>
      </StyledHeroContainer>
      {image && image.length > 0 && (
        <StyledBgImg>
          {image.map((content) =>
            React.createElement(Components(content.component), {
              key: content._uid,
              blok: content,
            })
          )}
        </StyledBgImg>
      )}
      <StyledShape>
        <img src={shape.filename} />
      </StyledShape>
    </StyledHero>
  )
}
